import script from "./itemV3StonesPresets.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3StonesPresets.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__